import store from '@/store'

const Anon = (endpoint) => {
  return `/anon/${ endpoint }/`
}

const Auth = (endpoint, id = null) => {
  return id
    ? `/a/${ endpoint }/${ id }/`
    : `/a/${ endpoint }/`
}

const Admin = (endpoint, id = null) => {
  return id
    ? `/a/admin/${ endpoint }/${ id }/`
    : `/a/admin/${ endpoint }/`
}

const CompanyHandler = (id) => {
  const agencyId = store.getters.selectedAgency
    ? store.getters.selectedAgency.id
    : 0

  return Auth(`agency/${ agencyId }/company`, id)
}

const ConsultationHandler = (id) => {
  const agencyId = store.getters.selectedAgency
    ? store.getters.selectedAgency.id
    : 0

  const companyId = store.getters.selectedCompany
    ? store.getters.selectedCompany.id
    : 0

  return Auth(`agency/${ agencyId }/company/${ companyId }/consultation`, id)
}

const ConsultationLightHandler = (id, suffix = '') => {
  const agencyId = store.getters.selectedAgency
    ? store.getters.selectedAgency.id
    : 0

  const companyId = store.getters.selectedCompany
    ? store.getters.selectedCompany.id
    : 0

  return Auth(`agency/${ agencyId }/company/${ companyId }/light${ suffix ? '/' + suffix : '' }`, id)
}

export default {
  Auth: {
    Login: Anon('auth/login'),
    Refresh: Auth('auth/refresh'),
    SetPassword: Anon('profile/set_password'),
    LoginSSO: Auth('ud/auth/get_user_data'),
    LoginLog: Auth('auth/log_login'),
  },

  Dev: {
    AppInfo: Anon('info'),
  },

  CreateAgency: () => Admin(`agency`),
  Agency: (id) => Auth(`agency`, id),
  AdminUser: (id) => Admin(`profile`, id),
  User: (id) => Auth(`profile`, id),
  Company: (id) => CompanyHandler(id),
  CompanyLogo: (id) => CompanyHandler(id) + 'logo/',
  Consultation: (id) => ConsultationHandler(id),
  ConsultationLightList: () => ConsultationLightHandler(null, 'list'),
  ConsultationLightCreate: () => ConsultationLightHandler(null, 'create'),
  ConsultationLightDelete: () => ConsultationLightHandler(null, 'delete'),
  ConsultationLightUpdate: () => ConsultationLightHandler(null, 'update'),
  ConsultationLightExport: () => ConsultationLightHandler(null, 'export'),
  ConsultationLight: (id) => ConsultationLightHandler(id),
  RuleEngine: Auth('rule_engine'),
  Statistics: () => Admin('statistics'),
  StatisticsExport: Admin('statistics_export')
}
